export const ModulePropsOption = {
    mode: { type: String, default: "" },
    specie: { type: Number },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;

export const ModuleEmits = {
    next: (_mode: "RNA-Splicer" | "Pathogenicity-Predictor") => true,
    codon: () => true,
    mutations: () => true,
};
